import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";

const COMMITMENTS = [
  "Body text of at least 16 pixels with strong color contrast",
  "Large, easy-to-tap buttons and form fields",
  "Full keyboard navigation with visible focus indicators",
  "Descriptive labels on every form field and alternative text on meaningful images",
  "Error messages that use text — not color alone",
  "Reduced-motion support for visitors who prefer less animation",
  "No autoplaying audio or video, pop-ups, or countdown pressure tactics",
  "Proper heading structure for screen readers",
];

export default function Accessibility() {
  return (
    <>
      <SEO title="Accessibility Statement | 1907 Insurance Group" description="Our commitment to an accessible website for all visitors, designed with WCAG 2.2 AA principles." />
      <PageHero eyebrow="Accessibility" title="A Website Everyone Can Use"
        intro="1907 Insurance Group is committed to a website that works for all visitors, including people using assistive technology. We design with WCAG 2.2 AA principles in mind." />
      <section className="py-16 md:py-24" data-testid="accessibility-content">
        <div className="container-site max-w-3xl">
          <Reveal>
            <h2 className="text-2xl tracking-tight">What That Means in Practice</h2>
            <ul className="mt-6 list-disc space-y-3 pl-6 text-lg text-mutedink leading-relaxed">
              {COMMITMENTS.map((c) => <li key={c}>{c}</li>)}
            </ul>
            <h2 className="mt-12 text-2xl tracking-tight">Need Help or Found a Barrier?</h2>
            <p className="mt-4 text-lg text-mutedink leading-relaxed">
              If any part of this website is difficult for you to use, we want to know — and we will gladly help you
              directly. Call <a href="tel:+18778331907" className="text-navy underline">(877) 833-1907</a>{" "}
              and we will provide the information or assistance you need in a way that works for you.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
